import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MixedResultInterface, Result, ResultInterface, ResultStatusEnum } from '@campus/dal';
import { ResultFunctions } from '@campus/utils';
import { ScoreScatterScoreInterface } from '../../interfaces';

@Component({
  standalone: false,
  selector: 'campus-score-scatter',
  templateUrl: './score-scatter.component.html',
  styleUrls: ['./score-scatter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScoreScatterComponent implements OnChanges {
  @HostBinding('class.pages-results-v2-score-scatter') hasScoreScatterClass = true;

  public scoreScatter = {
    low: 0,
    medium: 0,
    high: 0,
  };

  @Input() results: MixedResultInterface<ResultInterface>[] = [];
  @Input() scores: ScoreScatterScoreInterface[] = [];
  @Input() maxAmountScores: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.results) {
      this.scores = this.results.flatMap((result) => {
        // if (result.type !== 'result') return [];

        const res = result.data ? Result.toResult(result.data) : result;

        return res.status === ResultStatusEnum.STATUS_COMPLETED && res.score != null
          ? [{ score: res.score, maxScore: 100 }]
          : [];
      });
    }

    if (changes.scores || changes.results || changes.maxAmountScores) {
      const percentageScores = this.scores
        .filter((score) => score.score != null)
        .map((score) => (score.score / (score.maxScore ?? 100)) * 100);

      this.scoreScatter = ResultFunctions.mapToScatterInterface(percentageScores);
    }
  }
}
